import { getAreaInfoById, getMobileApps, getPartnerPromotions } from '@/store/slices/stagesSlice/stagesSlice';
import { Container, PaymentCard, SubscriptionCard, EventCard } from '@/components';
import styles from './AreaPage.module.scss';
import { useSelector } from 'react-redux';
import { RootState } from '@/store';
import cn from 'classnames';
import {  useLayoutEffect } from 'react';

import { useAreaStyles } from '@/helpers/hooks/useAreaStyles';
import { AreasSlug, storeLinks } from '@/constants';
import PaymentInAppCard from '@/components/Card/PaymentInAppCard';
import PaymentInKPlazaAppCard from '@/components/Card/PaymentInKPlazaAppCard';
import PartnerPromotions from '@/components/PartnerPromotions';
import { yandexMetrika } from '@/helpers/yandexMetrika';

export default function AreaPage({ id }: { id: string }) {
  useAreaStyles(id)
  const reduxState = useSelector<RootState, RootState>(state => state);
  const { data } = getAreaInfoById(reduxState, id);
  const { data: partnerPromotions } = getPartnerPromotions(reduxState)
  const { data: mobileApps } = getMobileApps(reduxState)
  const links = data?.footer_links ?? []
  const sortedLinks = links ? [...links].sort((a, b) => a.order - b.order) : []

  const isKashirskayaPlaza = id === AreasSlug.KashirskayaPlaza
  const isKapitoliyBelyaevo = id === AreasSlug.KapitoliyBelyaevo
  const isParkovkaZil = id === AreasSlug.ParkovkaZil

  useLayoutEffect(() => {
    const sheet = data?.customising.style_sheet;
    if (sheet) {
      document.body.style.setProperty('--font-main', `'${sheet}', sans-serif`);
      document.body.style.setProperty('--font-secondary', `'${sheet}', sans-serif`);
    }
  }, []);

  const isShowPartnerPromotions =
    partnerPromotions &&
    partnerPromotions?.length > 0 &&
    !isKashirskayaPlaza &&
    !isKapitoliyBelyaevo &&
    !isParkovkaZil;

  return (
    <div className={styles.container}>
      <section className={styles.section}>
        <div>
          <section className={styles.preview__wrapper}>
            <div className={styles.preview}>
              {data?.preview && (
                <img src={data.preview} alt={data?.name} className={styles.preview__image} />
              )}
            </div>
            {data?.customising.logo_circle ? (
              <div className={cn(styles.preview__logoCircle)}>
                <img
                  className={styles.preview__customisingLogo}
                  src={data?.customising.logo_circle}
                  alt="logo"
                />
              </div>
            ) : (
              <img className={styles.preview__logo} src={'/images/preview-logo.svg'} alt="logo" />
            )}
          </section>

          <h1 className={styles.title}>{data?.name}</h1>

          {!isKashirskayaPlaza && (
            <section className={styles.mobileApps}>
              <a href={mobileApps ? mobileApps.android_link : storeLinks.googlePlay} target="_blank" 
              rel="noreferrer noopener" onClick={yandexMetrika.reachGoalButtonClickGooglePlay}>
                <img
                  className={styles.mobileApp}
                  src="/images/google-play-prev.png"
                  alt="Google Play"
                />
              </a>
              {/*<a href={mobileApps ? mobileApps.ios_link : storeLinks.appStore} target="_blank" */}
              {/*rel="noreferrer noopener" onClick={yandexMetrika.reachGoalButtonClickAppStore}>*/}
              {/*  <img*/}
              {/*    className={styles.mobileApp}*/}
              {/*    src="/images/app-store-prev.png"*/}
              {/*    alt="App Store"*/}
              {/*  />*/}
              {/*</a>*/}
            </section>
          )}

          <div className={styles.cards}>
            {isShowPartnerPromotions && <PartnerPromotions partnerPromotions={partnerPromotions} />}
            {data?.show_rates && <PaymentCard areaId={id} />}
            {isKashirskayaPlaza && (
              <>
                <PaymentInKPlazaAppCard />
                <PaymentInAppCard mobileApps={mobileApps}  />
              </>
            )}
            {data?.show_subscriptions && <SubscriptionCard areaId={id} />}
            {data?.show_events && <EventCard areaId={id} />}
          </div>
        </div>
        {!!sortedLinks.length && (
          <Container>
            <footer className={styles.footer}>
              <div className={styles.footer__content}>
                <ul className={styles.footer__links}>
                  {sortedLinks.map(link => (
                    <li key={link.order}>
                      <a
                        className={styles.footer__linksItem}
                        href={link.url}
                        target="_blank"
                        rel="noopener"
                      >
                        {link.name}
                      </a>
                    </li>
                  ))}
                </ul>
                <img
                  className={styles.footer__image}
                  src="/images/payment-methods.svg"
                  alt="Способы оплаты"
                />
              </div>
            </footer>
          </Container>
        )}
      </section>
    </div>
  )
}
